module.exports = __webpack_public_path__ + "media/images/pic/groups/early-school-d542611d2f23f236db1058a607d9a990.jpg";